<template>
    <div class="drawDetail">
        <div class="con flex jb ">
            <div flex-center class="close"@click="back"><i class="el-icon-close"></i></div>
            <div class="big_img" flex-center>
                <el-image fit="contain" :src="square_data.img_url+'?width='+square_data.s_w+'&height='+square_data.s_h" :preview-src-list="[square_data.raw_img_url]"></el-image>
            </div>
            <div class="text_area">
                <div class="user flex jb ac">
                    <div class="info flex  ac">
                        <div class="avatar">
                            <img src="https://www.midjourny.cn/images/square.png"
                                 alt=" " />
                        </div>
                        <div class="name">
                            <p class="nickname">白日梦</p>
                            <p class="flex ac"><img src="./img/icon_img50.png" style="color: #FC8C0A;"
                                     alt=" " /><span>{{square_data.views}}</span><img src="./img/icon_img51.png"
                                     alt=" " /><span>{{square_data.votes}}</span></p>
                        </div>
                    </div>
                    <div class="fav flex jc ac" @click="handleVote">
                        <img src="./img/icon_img51.png"
                             alt=" " />
                        <p>点赞</p>
                    </div>
                </div>
                <div class="item">
                    <div class="title flex jb ac">
                        <p>提示词</p>
                        <p class="flex ac" v-clipboard:copy="square_data.prompt" v-clipboard:success="copySuccess"
                                    v-clipboard:error="copyError"><img src="./img/icon_img52.png"  alt=" " /><span>复制</span></p>
                    </div>
                    <div class="desc">
                        {{ square_data.prompt }}
                    </div>
                </div>
                <div class="item">
                    <div class="title flex jb ac">
                        <p>英文</p>
                        <p class="flex ac" v-clipboard:copy="square_data.prompt_en" v-clipboard:success="copySuccess"
                                    v-clipboard:error="copyError"><img src="./img/icon_img52.png"
                                 alt=" " /><span>复制</span></p>
                    </div>
                    <div class="desc">
                        {{ square_data.prompt_en }}
                    </div>
                </div>
                <div class="item">
                    <div class="title flex jb ac">
                        <p>参数信息</p>
                    </div>
                    <div class="desc">
                        <div class="params_item flex ac">
                            <p class="title">绘制模型</p>
                            <p class="tips">{{square_data.img_model}}</p>
                        </div>
                        <div class="params_item flex ac">
                            <p class="title">图片比例</p>
                            <p class="tips">{{square_data.aspect}}</p>
                        </div>
                        <div class="params_item flex ac">
                            <p class="title">图片尺寸</p>
                            <p class="tips">{{square_data.width}}:{{ square_data.height }}</p>
                        </div>
                        <div class="params_item flex ac">
                            <p class="title">高级参数</p>
                            <p class="tips">{{square_data.parameters}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            draw_id: this.$route.query.draw_id || 0,
            square_data: {},
            is_vote:0
        }
    },
    created () {
        this.getData()
    },
    methods: {
        getData () {
            //发送请求
            this.$http.get(`/front/aimj/draw/${this.draw_id}/`).then((res) => {
                this.square_data = res.data
            })
        },
        back () {
            this.$router.go(-1)
        },
        handleVote(){
            this.$http.patch(`/front/aimj/draw/${this.draw_id}/`,{action:'vote'}).then((res) => {
                if(this.is_vote){
                    this.is_vote = 0
                    this.square_data.votes = this.square_data.votes - 1
                }else{
                    this.is_vote = 1
                    this.square_data.votes = this.square_data.votes + 1
                }
            })
        },
        copySuccess() {
            this.$message.success('复制成功！');
        },
        copyError() {
            this.$message.error('复制失败！');
        },
    }
}
</script>

<style lang="scss" scoped>
.drawDetail {
    height: 100%;
    padding: 20px;
    overflow-y: auto;
    .con {
        flex-wrap: wrap;
        width: 100%;
        padding: 16px;
        background: #303237;
        border-radius: 15px;
        position: relative;
        font-size: 12px;
        .close {
            background-color: #414141;
            right: 10px;
            top: 10px;
            position: fixed;
            z-index: 100;
            height: 50px;
            width: 50px;
            border-radius: 25px;
            font-size: 20px;
            color: #fff;
            font-weight: bold;
        }
        .big_img {
            flex: 1;
            max-width: 100%;
            height: 600px;
            .el-image {
                width: 100%;
                height: 100%;
            }
        }
        .text_area {
            .user {
                margin-bottom: 34px;
                .info {
                    .avatar {
                        width: 46px;
                        height: 46px;
                        background: #acacac;
                        border-radius: 100%;
                        overflow: hidden;
                        margin-right: 10px;
                        img {
                            width: 100%;
                        }
                    }
                    .name {
                        p {
                            img {
                                width: 16px;
                                height: 16px;
                                opacity: 0.5;
                            }
                            span {
                                margin-left: 5px;
                                margin-right: 10px;
                                font-size: 12px;
                                color: #999;
                                position: relative;
                                top: 2px;
                            }
                        }
                        .nickname {
                            font-size: 14px;
                            color: #fff;
                            margin-bottom: 5px;
                        }
                    }
                }
                .fav {
                    width: 80px;
                    height: 40px;
                    border-radius: 40px;
                    background: #000;
                    cursor: pointer;
                    img {
                        width: 16px;
                        height: 16px;
                        margin-right: 5px;
                    }
                    p {
                        font-size: 12px;
                        color: #fff;
                    }
                    &:hover {
                        opacity: 0.8;
                    }
                }
            }
            .item {
                margin-top: 10px;
                .title {
                    p {
                        font-size: 14px;
                        color: #fff;
                    }

                    img {
                        width: 24px;
                        height: 24px;
                        opacity: 0.7;
                    }
                    span {
                        font-size: 12px;
                        color: #999;
                    }
                    .flex {
                        cursor: pointer;
                        &:hover {
                            img {
                                opacity: 1;
                            }
                            span {
                                color: #fff;
                            }
                        }
                    }
                }
                .desc {
                    background-color: #262626;
                    color: #fff;
                    padding: 16px;
                    min-height: 60px;
                    //max-height: 160px;
                    border-radius: 10px;
                    line-height: 1.7;
                    margin-top: 10px;

                    .params_item {
                        padding: 5px 0;
                        .title {
                            color: #949ba4;
                            margin-right: 10px;
                        }
                        .tips {
                            color: #fff;
                        }
                    }
                }
            }
        }
    }
}
</style>